import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/deepesh/Development/public/rovaa/dipisha-book-website/apps/admin/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/home/deepesh/Development/public/rovaa/dipisha-book-website/packages/styles/tailwind-base.css");
;
import(/* webpackMode: "eager" */ "/home/deepesh/Development/public/rovaa/dipisha-book-website/packages/styles/prosemirror.css");
;
import(/* webpackMode: "eager" */ "/home/deepesh/Development/public/rovaa/dipisha-book-website/node_modules/.pnpm/katex@0.16.22/node_modules/katex/dist/katex.min.css");
